<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-window v-model="windowPage" style="width: 100%;" touchless>

            <v-window-item :key="0">
                <div id="ag-grid-container">
                    <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                        :gridOptions="gridOptions"
                        @row-double-clicked="(params) => editNetworkCategory(params.data)"
                        :groupHeaders="true"
                        :rowHeight="40">
                    </ag-grid-vue>
                </div>
                <v-btn color="#c42111" class="mt-3 mr-3" @click="newNetworkCategory" :disabled="lockSave" v-if="showGrid">New</v-btn>
            </v-window-item>

            <v-window-item :key="1">
                <network-category-edit :networkCategory="selectedNetworkCategory" :lockSave="lockSave" @save="saveNetworkCategory" @cancel="windowPage = 0"></network-category-edit>
            </v-window-item>
        

        </v-window>
    </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import NetworkCategoryEdit from "@/components/NetworkCategories/NetworkCategoryEdit";
export default {
    name: 'NetworkCategories',
    props: [],
    components: {
        'ag-grid-vue': AgGridVue,
        NetworkCategoryEdit
    },
    data: () => ({
        showGrid: false,
        networkCategoryList: [],
        savedNetworkCategoryIndex: null,
        windowPage: 0,
        lockSave: false,
        selectedNetworkCategory: null
    }),

    computed: {

    },

    methods: {
        getNetworkCategoryList: function() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "networkcategories/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.networkCategoryList = result;
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.networkCategoryList;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridOptions.api.sizeColumnsToFit();
                if(self.savedNetworkCategoryIndex) {
                    self.gridOptions.api.ensureIndexVisible(self.savedNetworkCategoryIndex, 'middle');
                }
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport',
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'networkCategories');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle user-tres-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle user-tres-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.user-tres-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.user-tres-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.editNetworkCategory(params.data);
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteNetworkCategoryClick(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Category Name', 
                    field: 'network_category_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Icon', 
                    field: 'network_category_icon', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    cellRenderer: function(params) {
                        let eElement = document.createElement('div');
                        eElement.innerHTML = `<span class="mdi ${params.data.network_category_icon}" style="color: ${params.data.network_category_color}; font-size: 20pt" />
                        <span style="color: #000000; font-size: 12px; vertical-align: top;">${params.data.network_category_icon}</span>`
                        return eElement;
                    }
                },
                { 
                    headerName: 'Color', 
                    field: 'network_category_color', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                    cellRenderer: function(params) {
                        let eElement = document.createElement('div');
                        eElement.innerHTML = `<span class="mdi mdi-checkbox-blank-circle" style="color: ${params.data.network_category_color}; font-size: 20pt; text-shadow: -1px 0 #000, 0 1px #000, 1px 0 #000, 0 -1px #000;" />
                        <span style="color: #000000; font-size: 12px; vertical-align: top; text-shadow: none">${params.data.network_category_color}</span>`
                        return eElement;
                    }
                },
            ];
            return columnDefs;
        },

        editNetworkCategory: function(networkCategory) {
            if(this.lockSave) {
                return;
            }
            this.selectedNetworkCategory = JSON.parse(JSON.stringify(networkCategory));
            this.windowPage = 1;
        },

        saveNetworkCategory: function(networkCategory, editSites, sites) {
            console.log('saving sites: ', sites);
            TELSA.loading(true);
            let route = (TELSA.apiHost + "networkcategories/edit");
            if(networkCategory.network_category_id == 0) {
                route = (TELSA.apiHost + "networkcategories/add");
            }
            let site_ids = sites.map(s => {return s.site_id});
            this.$http.post(route, {args: {networkCategory: networkCategory, editSites: editSites, sites: site_ids}}).then(response => {
                let result = response.body;
                this.windowPage = 0;
                if(networkCategory.network_category_id) {
                    this.savedNetworkCategoryIndex = this.networkCategoryList.findIndex(n => n.network_category_id == networkCategory.network_category_id);
                }
                if(editSites) {
                    this.$store.dispatch('handleRemoveLocks', {});
                }
                this.getNetworkCategoryList();
            });
        },

        deleteNetworkCategoryClick: function(networkCategory) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Network Category',
                message: `This operation will delete this network category and will be removed from any sites it is assigned to. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteNetworkCategory(networkCategory)
            });
        },

        deleteNetworkCategory: function(networkCategory) {
            TELSA.loading(true);
            let route = (TELSA.apiHost + "networkcategories/delete");
            this.$http.post(route, {args: {networkCategory: networkCategory}}).then(response => {
                let result = response.body;
                this.getNetworkCategoryList()
            });
        },

        newNetworkCategory: function() {
            this.selectedNetworkCategory = {
                network_category_id: 0,
                network_category_name: '',
                network_category_icon: '',
                network_category_color: ''
            };
            this.windowPage = 1;
        }

    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/network-categories');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){self.getNetworkCategoryList()}
            });
            this.lockSave = true;
            return;
        }

        this.getNetworkCategoryList();
    }

  
};
</script>

<style scoped>

    .data-container {
        display: block;
        padding: 0;
    }

    #ag-grid-container {
        height: calc(100vh - 126px);
        width: 100%;
    }

</style>
